import { useRecoilState } from "recoil";
import { ModalTypeState, SelectedCustomerState } from "../../atoms";
import { BaseModal } from "./BaseModal";
import { CustomersClient } from "../../services";
import { GetNewInstance } from "../../helpers/HttpCommon"
import { ModalTypes } from ".";


type Props = {
    onSuccess: () => void;
}

export function ActivateCustomerModal({ onSuccess }: Props) {

    const [, setModalType] = useRecoilState(ModalTypeState);
    const [selectedCustomer, setSelectedCustomer] = useRecoilState(SelectedCustomerState);

    const client = new CustomersClient(undefined, GetNewInstance());

    const onCancel = () => {
        setSelectedCustomer(null);
        setModalType(null);
    }

    const onActivateClick = () => {
        selectedCustomer?.id && client.activateCustomer(selectedCustomer?.id)
            .then(x => {
                onSuccess();
            })
            .finally(() => {
                setSelectedCustomer(null);
                setModalType(null);
            })
    }

    return (
        <BaseModal id={ModalTypes.ActivateCustomerModal} title="Activate customer" description={"Are you sure you want to activate " + selectedCustomer?.name + "?"}>
            <div className="py-4 text-sm text-white">
                <div className="mt-8 flex justify-end gap-4">
                    <button onClick={onCancel}
                        className="py-2.5 px-4 rounded-md border border-page-border bg-white bg-opacity-5 hover:bg-opacity-10">Cancel
                    </button>
                    <button onClick={onActivateClick}
                        className="py-2.5 px-4 rounded-md bg-button-bg-primary-default hover:bg-button-bg-primary-hover active:shadow-button-bg-primary-default">
                        Activate</button>
                </div>
            </div>
        </BaseModal>
    );
}